var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ai', _vm.cropsMark]},[_c('h2',{staticClass:"ai-page-title"},[_vm._v("选择基地：")]),_c('AiMenubar',{attrs:{"isMenubar":_vm.isMenubar}}),_c('MyNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }